<template>
  <Loader :value="promise" theme="default" class="task-reference-comment">
    <Comment v-if="item" :value="item">
      <template #actions>
        <ButtonComponent
          v-if="showAction && action"
          tag="router-link"
          :to="action"
          :label="$t('gotoItem', [$tc('message', 1).toLowerCase()])"
          :icon="['fal', 'arrow-to-right']"
          class="task-reference-comment__action"
        />
      </template>
    </Comment>
  </Loader>
</template>

<script>
import Api from '@/api/Comment'
import { LeadPathByModel } from '@/components/Lead/utils'
import Comment from '@/components/Comment/Item'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  computed: {
    showAction() {
      return this.action.name !== this.$route.name
    },
    action() {
      switch (this.item.reference.onModel) {
        case 'Lead':
          const context = LeadPathByModel[this.$path('reference.reference.onModel', this.item) || 'Project']

          return {
            name: `${context}-lead`,
            params: { id: this.item.reference.id, reference: this.item.reference.reference.id },
          }
        case 'Contact':
          return {
            name: 'contact-dashboard',
            params: { id: this.item.reference.id },
          }
      }
    },
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceComment' }).then(item => (this.item = item))
    },
  },
  components: {
    Comment,
  },
}
</script>

<style lang="scss">
.task-reference-comment {
  flex-grow: initial;

  .comment__action {
    display: none;
  }

  &__action {
    font-size: 0.8em !important;
  }
}
</style>
